import { NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { CoreModule } from '@core/core.module';
import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';
import { ThemeModule } from '@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { JwtInterceptor, ErrorInterceptor } from '@pages/auth/_helpers';
import { AuthLoginComponent } from '@pages/auth/login/login.component';
import { AuthLogoutComponent } from '@pages/auth/logout/logout.component';
import { MoghimCore2010Proxy } from '@core/proxies/MoghimCore2010Proxy';
import { NewAuthLoginComponent } from '@pages/auth/login/newlogin.component';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NgxCaptchaModule,
        
        NgbModule.forRoot(),
        ThemeModule.forRoot(),
        CoreModule.forRoot(),
    ],
    declarations: [
        AppComponent,
        AuthLoginComponent,
        AuthLogoutComponent,
        NewAuthLoginComponent
    ],
    bootstrap: [AppComponent],
    providers: [
        MoghimCore2010Proxy,
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
    ],
})
export class AppModule {
}